var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-checkbox',{staticClass:"mt-5",attrs:{"color":"primary","on-icon":"mdi-moon-waxing-crescent","off-icon":"mdi-white-balance-sunny"},on:{"change":_vm.updateDarkMode},model:{value:(_vm.dark),callback:function ($$v) {_vm.dark=$$v},expression:"dark"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }